import template from './service_settings.html'
import controller from './service_settings.controller'
import './service_settings.scss'

const serviceSettingsComponent = {
    restrict: 'E',
    bindings: {
        acl: '=',
        hasACL: '='
    },
    template,
    controller
}

export default serviceSettingsComponent;


// WEBPACK FOOTER //
// ./client/app/components/service_settings/service_settings.component.js